export class ResetPasswordRequest {
  constructor(
    public userName: string,
    public token: string,
    public newPassword: string,
    public rememberPhrase: string
  ) {}
}
